<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" style="float: right;" @click="addFormVisible = true">新增作品</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="imageUrl"
          label="作品地址">
          <template slot-scope="scope">
            <img  :src="scope.row.imageUrl" alt="" style="height: 100px">
          </template>
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          property="createTime"
          label="上传时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="Viewmaterial(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="Editmaterial(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

      <!--新增排版-->
      <el-dialog title="新增作品" :visible.sync="addFormVisible" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="图片附加" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>

      <!--查看排版-->
      <el-dialog title="查看作品" :visible.sync="addFormExpress" width="30%">
        <el-form :model="addForms" label-width="80px" ref="addForm">
          <el-form-item label="图片附件:" prop="name">
            <img v-bind:src="addForms.imageUrl" style="width: 80%">
          </el-form-item>
        </el-form>
      </el-dialog>

      <!--编辑排版-->
      <el-dialog title="编辑边框" :visible.sync="addFormVisible2" v-loading="loading">
        <el-form :model="addForms" label-width="80px" ref="addForms">
          <el-form-item label="最新图片" prop="name">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemoves"
              :on-success='handlesuccesss'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="原图:" prop="name">
            <img v-bind:src="imageUrls" style="width: 80%">
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="cancel2">取消</el-button>
          <el-button type="primary" @click="addSubmits()" >提交</el-button>
        </div>
      </el-dialog>


    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getremakes,getaddfremakes,getmodfremakes,getdelfremakes  } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        addFormVisible: false,//新增界面是否显示
        addFormVisible2: false,
        addFormExpress: false,
        //新增界面数据
        addForm: {
          imageUrl:''
        },
        addForms: {
          imageUrl:''
        },
        imageUrls:'',
        fileList:[],
        myHeaders: {token: sessionStorage.token},
        loading:false
      }
    },
    components: {
      headTop,
    },
    activated(){
      this.getremakes();
    },

    methods: {
      formatDate:function (value){
        var dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getremakes()
      },
      getremakes(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取排版管理列表
        getremakes(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      //新增作品
      handlesuccess(response, file, fileList){
        if(file.response.state == true){
          this.addForm.imageUrl = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      //新增作品
      addSubmit(){
        if (this.addForm.imageUrl == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        } else {
          this.loading = true
          let params={
            imageUrl:this.addForm.imageUrl,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getaddfremakes(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addForm ={
                imageUrl:''
              },
              this.fileList = []
              this.getremakes()
              this.addFormVisible = false
            }else{
              this.$message({
                type: 'error',
                message: '请填写完整信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }
      },
      cancel(){
        this.addForm ={
          imageUrl:''
        },
        this.fileList = []
        this.addFormVisible = false
      },
      cancel2(){
        this.addFormw ={
          imageUrl:''
        },
        this.fileList = []
        this.addFormVisible2 = false
      },
      Viewmaterial(index,row){
        //  查看边框详情
        this.addForms.imageUrl = row.imageUrl
        this.addFormExpress = true
      },
      Editmaterial(index,row){
        //  编辑排版
        this.addFormVisible2 = true
        this.imageUrls = row.imageUrl
        this.addForms.imageUrl = row.imageUrl
        this.addForms.operateId = JSON.parse(sessionStorage.getItem('user')).id
        this.addForms.id = row.id
      },
      //编辑作品赏析
      handlesuccesss(response, file, fileList){
        if(file.response.state == true){
          this.addForms.imageUrl = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      addSubmits(){
        this.loading = true
        let params={
          imageUrl:this.addForms.imageUrl,
          operationId:this.addForms.operateId,
          id:this.addForms.id
        };
        getmodfremakes(params).then(res=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.loading = false
            this.getremakes()
            this.fileList = []
            this.addFormVisible2 = false;
          }else{
            this.$message({
              type: 'error',
              message: '请填写完整信息'
            });
            this.loading = false
          }
        }).catch(error=>{
          this.loading = false
          console.log(error)
        })
      },
      handleDelete(index, row){
        //删除排版
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            id:row.id,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getdelfremakes(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      handleRemove(file, fileList) {
        this.addForm.imageUrl = ''
      },
      handleRemoves(file, fileList) {

      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张图片`);
        return false
      },
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
</style>



// WEBPACK FOOTER //
// src/page/remarks.vue